module.exports = __webpack_public_path__ + "static/media/audit.da3ff731.svg";